module.exports = __webpack_public_path__ + "static/media/task-pencil-icon.4cc0968c.svg";